import { useQuery } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

export const useSupplierDetails = (supplierId: string) => {
    return useQuery(queries.suppliers.detail(supplierId));
};
